export const getSafeBlob = (data, contentType) => {
  try {
    return new Blob(data, contentType)
  }
  catch (e) {
    // Old browser which can't handle it without making it an byte array (ie10, ie11)
    if (e.name === 'InvalidStateError') {
      const byteArray = new Uint8Array(data[0])
      return new Blob([byteArray.buffer], contentType)
    }

    throw new Error('Could not generate Blob using getSafeBlob()')
  }
}

export function createObjectURL(blob){
  if (blob) {
    const urlCreator = window.URL || window.webkitURL
    return urlCreator.createObjectURL(blob)
  }
}

export function revokeObjectURL(objectURL){
  if (objectURL && objectURL.search('blob:') > -1) {
    const urlCreator = window.URL || window.webkitURL
    urlCreator.revokeObjectURL(objectURL)
  }
}

export const autoDownload = (fileUrl, fileName = 'file') => {
  let a = document.createElement('a')
  a.setAttribute('href', fileUrl)
  a.setAttribute('download', fileName)
  a.click()
  a = null
}

export const autoDownloadBlob = (blob, fileName) => {
  const blobUrl = window.URL.createObjectURL(blob)
  autoDownload(blobUrl, fileName)
}

export const autoDownloadBase64 = (base64, fileType, fileName) => {
  const fileUrl = `data:${fileType};base64, ${base64}`
  autoDownload(fileUrl, fileName)
}

export const createBlobFormUrlAndDownload = async (url, name) => {
  try {
    const blob = await fetch(url).then(res => res.blob())
    return autoDownloadBlob(blob, name)
  } catch (err) {
    throw new Error(`Could not generate Blob from url ${url}`)
  }
}

export const createTextBlobAndDownload = async (str, name) => {
  try {
    const file = new Blob([str], {type: 'text/html'})
    const fileURL = URL.createObjectURL(file)
    autoDownload(fileURL, name)
  } catch (err) {
    throw new Error(`Could not generate text ${name}`)
  }
}
